__turbopack_context__.v({
  "root": "CopyBlock-module__4ii6Sa__root",
});
